import { render, staticRenderFns } from "./pblmWarranty.vue?vue&type=template&id=47eff230&scoped=true&"
import script from "./pblmWarranty.vue?vue&type=script&lang=js&"
export * from "./pblmWarranty.vue?vue&type=script&lang=js&"
import style0 from "./pblmWarranty.vue?vue&type=style&index=0&id=47eff230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eff230",
  null
  
)

export default component.exports